import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const ActivitySkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className={style.activityBlock}>
      <div className={style.blockHead}>
        <div className={style.blockTitle}>{t('Comments')}</div>
      </div>
      <div className={style.blockContainer}>
        <div className={style.activityForm}>
          <div className={style.activityFormWrapper}>
            <SkeletonBlock className={style.skeletonForm} />
          </div>
        </div>
        <div className={style.commentsWrapper}>
          {[...Array(5)].map((_) => (
            <div key={uuidv4()} className={style.skeletonComment}>
              <div className={style.skeletonCommentHeadWrapper}>
                <div>
                  <SkeletonBlock className={style.skeletonAvatarIcon} />
                </div>
                <SkeletonBlock className={style.skeletonCommentTitle} />
              </div>
              <SkeletonBlock className={style.skeletonCommentText} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActivitySkeleton;
